/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventFileOperationRequest
 */
export interface EventFileOperationRequest {
    /**
     * 
     * @type {string}
     * @memberof EventFileOperationRequest
     */
    fileId: string;
}

/**
 * Check if a given object implements the EventFileOperationRequest interface.
 */
export function instanceOfEventFileOperationRequest(value: object): value is EventFileOperationRequest {
    if ((!('fileId' in (value as Record<string, any>)) && !('file_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['fileId'] === undefined && (value as Record<string, any>)['file_id'] === undefined)) return false;
    return true;
}

export function EventFileOperationRequestFromJSON(json: any): EventFileOperationRequest {
    return EventFileOperationRequestFromJSONTyped(json, false);
}

export function EventFileOperationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventFileOperationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fileId': json['file_id'],
    };
}

export function EventFileOperationRequestToJSON(json: any): EventFileOperationRequest {
    return EventFileOperationRequestToJSONTyped(json, false);
}

export function EventFileOperationRequestToJSONTyped(value?: EventFileOperationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file_id': value['fileId'],
    };
}

